module.exports = __webpack_public_path__ + "media/images/categories/carousel/transport-and-travel-39ef6019181f9098fc9e6385b34400ae.jpg";